/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Footer from '../components/Footer';
import { speak, beelineText } from '../actions';
import backpack from '../assets/404/backpack.png';

const FourOhFour = (props) => {
  return (
    <div className="FourOhFour-background">
      <div className="FourOhFour-container">
        <div className="FourOhFour-backpack-container">
          <img src={backpack} className="FourOhFour-backpack" alt="backpack" />
        </div>
        <div className="FourOhFour-text-container">
          <h3 className={`${props.speechEnabled && 'bolded'}`} onClick={props.speak}>Page Not Found</h3>
          <p className={`color ${props.speechEnabled && 'bolded'}`} onClick={props.speak}>Sorry but the page you were looking for has moved or does not exist</p>
          <button type="button" onClick={() => { props.history.push('/'); }}>Go to Home Page</button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => (
  { speechEnabled: state.speech.enabled }
);

export default connect(mapStateToProps, {
  speak, beelineText,
})(withRouter(FourOhFour));
